import 'gridstrap/svg-symbols/award-ribbon.svg?sprite';
import './tab-bar.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSTabBar } from './tab-bar';

components.register({
	selector: '.gs-TabBar',
	controller: GSTabBar
});
